module.exports = __webpack_public_path__ + "img/tree-05-e-leaves.a88babaf.png";